export const pickRandomIndices = (total: number, count: number): number[] => {
  const actualCount = Math.min(total, count);
  const indices = Array.from({ length: total }, (_, i) => i);
  const selectedIndices = [];

  for (let i = 0; i < actualCount; i++) {
    const random = Math.floor(Math.random() * indices.length);
    selectedIndices.push(indices.splice(random, 1)[0]);
  }

  return selectedIndices;
};
